module.exports = __webpack_public_path__ + "img/Bank Muamalat.22f27036.png";